// Widget Scripts
import mainSlideshow from './js/widgets/mainSlideshow.js';
import seo from './js/widgets/seo.js';
import imagepromos from './js/widgets/imagepromos.js';
import maplinkaddress from './js/widgets/mapLinkAddress.js';
import mapImage from './js/widgets/mapImage.js';
import mainmultischedulefeature from './js/widgets/mainmultiScheduleFeature.js';
import cardsocialicon from './js/widgets/cardsocialicon.js';

//Fair Theme Widget
// Widget Scripts
import wcngSubpageCards from './js/fairlandingpage/wcngSubpageCards.js';
import wcngSubpageSEO from './js/fairlandingpage/wcngSubpageSEO.js';
import mainFeatureSlideShow from './js/fairlandingpage/mainFeatureSlide.js';
import cardMap from './js/fairlandingpage/cardMap.js';
import fairSponsors from './js/fairlandingpage/faircssSponsors.js';
import sponsorWidgetContainer from './js/fairlandingpage/cssSponsors.js';
import managedeventfeed from './js/fairlandingpage/managedeventfeed.js';
// Custom Theme Scripts
import './js/localjs.js';
import './js/Fairlocaljs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    mainSlideshow();
    seo();
    imagepromos();
    maplinkaddress();
    mapImage();
    mainmultischedulefeature();
  });
}

$(document).ready(function () {
  //footer
  cardsocialicon();
  if ($('body').hasClass('fair-landing-page')) {
    wcngSubpageCards();
    // fairSubPageSocialIcon();
    wcngSubpageSEO();
    mainFeatureSlideShow();
    // multiScheduleFeature();
    cardMap();
    fairSponsors();
    sponsorWidgetContainer();
    managedeventfeed();
  }
});
